/**
 * @file: The text that the calendar shows when the server refuses a write.
 *
 * Two paths write an interval. They are the save of the panel and the drag or
 * resize of a bar. Both show the same text for a refusal, so the text is in
 * this file.
 */

import { formatRange } from 'common/date-time'

/**
 * A rejection includes the rows that conflict. Show the times of those rows.
 *
 * The operator can find a time on the grid. The operator cannot find a
 * priority, because the server assigns it. To name the priority would offer a
 * control that does not exist.
 */
export function describeSaveError (error) {
  if (!error) {
    return 'Unknown error. Please try again.'
  }

  const conflicts = Array.isArray(error.conflicts) ? error.conflicts : []
  if (conflicts.length === 0) {
    return error.message || 'Unknown error. Please try again.'
  }

  const listed = conflicts.slice(0, 3)
    .map(conflict => formatRange(conflict.start_datetime, conflict.end_datetime))
    .join(', ')
  const more = conflicts.length > 3 ? ` and ${conflicts.length - 3} more` : ''

  return `${error.message} Clashes with: ${listed}${more}.`
}
